export const tableRefreshReasonTypes = {
  DELETED: 'DELETED',
  CREATED: 'CREATED',
  ADDED: 'ADDED',
  UPDATED: 'UPDATED',
  MOVED: 'MOVED',
  WATCHLIST_STATE_CHANGED: 'WATCHLIST_STATE_CHANGED',
  PRODUCT_REQUESTED: 'PRODUCT_REQUESTED',
  FILTERS_APPLIED: 'FILTERS_APPLIED',
  SUBSCRIPTION_PURCHASED: 'SUBSCRIPTION_PURCHASED',
};
